import { Injectable } from '@angular/core';
import {first} from "rxjs/operators";
import {SharedDataService} from '../../shared/shared.data.service';
import {TenantService} from '../../tenant/tenant.service';
import {JobsiteService} from '../../jobsite/jobsite.service';
import {CustomerService} from '../../customer/customer.service';
import {BidDataService} from "./bid.data.service";
import {ProposalService} from "../proposal/proposal.service";
import {ProposalDataService} from "../proposal/proposal.data.service";

@Injectable({
  providedIn: 'root'
})
export class BidService {

  public scopes: any;
  public stages: any;
  public sources: any;
  public staffs: any;
  public customers: any;
  public contacts: any;
  public jobsites: any;
  public bidTypes: any;

  public previewData:any = {};

  constructor(
    private sharedDataService: SharedDataService,
    public tenantService: TenantService,
    public customerService: CustomerService,
    public jobsiteService: JobsiteService,
    public bidDataService: BidDataService,
    public proposalDataService: ProposalDataService
  ) {}


  getBids = (params: any = {}) => {
    return this.bidDataService.list(params);
  }

}
